<template>
  <div
    class="theme-autocomplete-custom__field-holder"
    :class="{
        'theme-input__field-holder--is-disabled': disabled,
        'theme-input__field-holder--error': !!errors.has(newName) && !model,
        'theme-input__field-holder--focused': isFocused,
       }"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <label class="theme-input__label" v-if="label">
      {{ label }}
    </label>
    <div class="theme-autocomplete-custom">
      <div class='theme-autocomplete-custom__input-wrapper'>
        <input type='hidden' :name='name' :value='model'/>
        <input
          class='theme-input'
          v-model='model'
          type='text'
          :name='`_labels[${name}]`'
          autocomplete='off'
          @keyup='suggest'
          @keydown='clearTimeout'
          @keydown.enter.prevent
          :disabled='disabled'
          @blur='
            blur();
            isFocused = false;
          '
          @focus="
            $emit('focus', $event);
            isFocused = true;
          "
        />

        <span v-if="errors.has(newName)" class="icon-warning theme-input__icon theme-input__icon-error"></span>
      </div>
      <ul class='theme-autocomplete-custom__list' v-show='showList && suggestions.length'>
        <li
          v-for='(item, index) in suggestions'
          class='theme-autocomplete-custom__item'
          :class="{ 'theme-autocomplete-custom__item--is-selected': item === selected }"
          :key='index'
          @click='pick(item)'
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div
      v-if='(!!errors.has(newName) && !model) || !!errors.has(newName)'
      class='theme-input__error-text'
    >
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import _ from "lodash";
  import field from '../admin/mixins/field';

  export default {
    props: {
      options: {
        default: [],
        type: Array,
      },
      value: {
        default() {
          return [];
        },
      },
      initial: {
        default: "",
        type: String,
      },
      label: {
        default: "",
        type: String,
      },
    },
    data() {
      return {
        showList: false,
        selected: null,
        suggestions: [],
        model: this.initial,
        typingTimer: null,
        showOptionsInterval: 400,
        isFocused: false
      };
    },
    methods: {
      suggest(event) {
        let keyCode = event.keyCode;

        switch (keyCode) {
          case 38:
            if (_.indexOf(this.suggestions, this.selected) === 0) {
              this.selected = this.suggestions[this.suggestions.length - 1];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) - 1
                ];
            }
            break;
          case 40:
            if (
              _.indexOf(this.suggestions, this.selected) ===
              this.suggestions.length - 1
            ) {
              this.selected = this.suggestions[0];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) + 1
                ];
            }
            break;
          case 13:
            this.pick(this.selected);
            break;
          case 9:
            break;
          default:
            this.typing();
            break;
        }
      },
      showOptions() {
        let val = this.model,
          i = 0,
          arr = [...new Set(this.options)];

        this.suggestions = [];

        for (i = 0; i < arr.length; i++) {
          if (arr[i].indexOf(val) !== -1) {
            this.suggestions.push(arr[i]);
          }
        }
      },
      pick(item) {
        this.model = item;
        this.showList = false;
        this.selected = null;
      },
      typing() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.showOptions, this.showOptionsInterval);

        this.showList = true;
      },
      clearTimeout() {
        clearTimeout(this.typingTimer);
      },
      blur() {
        setTimeout(() => {
          this.showList = false;
        }, 300);
      },
    },
    mixins: [field],
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeAutocompleteCustom.vue